import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-toggle-with-text',
    templateUrl: './toggle-with-text.component.html',
    styleUrls: ['./toggle-with-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleWithTextComponent implements OnInit {
  @Input() items: string[];
  @Input() startItem: string;
  @Output() activeItemChanged = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  setActive(value) {
    this.startItem = value;
    this.activeItemChanged.emit(value);
  }

  isActive(value) {
    // tslint:disable-next-line: triple-equals
    return this.startItem == value;
  }

}
